import {ValueObject} from '@s-ui/domain'

/**
 * @class
 * @param {Object} params
 * @param {Object} params.segmentation
 * @param {String} params.pageName
 * @param {String} params.url
 */
export default class AdvertisingPageDataObject extends ValueObject {}
